import React from "react";
import LeftSidebarMenu from "../../../shared/Layout/LeftSidebarMenu";

function LeftNavigation({ toggleActive }) {
  return (
    <LeftSidebarMenu
      menuSections={[
        {
          title: "Сторінки",
          items: [
            {
              label: "Дашборд",
              path: "/supervisor/dashboard/",
              icon: "dashboard",
              resource: "supervisor.dashboard",
            },
            {
              label: "Скрипти",
              path: "/supervisor/scripts/",
              icon: "contact_page",
              resource: "supervisor.scripts",
            },
            {
              label: "Оператори",
              path: "/supervisor/operators/",
              icon: "person_outline",
              resource: "supervisor.operators",
            },
            {
              label: "Графік роботи",
              path: "/supervisor/work-schedule/",
              icon: "date_range",
              resource: "supervisor.work_schedule",
            },
            {
              label: "CRM",
              path: "/supervisor/crms",
              icon: "business",
              resource: "supervisor.crm",
            },
          ],
        },
      ]}
      toggleActive={toggleActive}
    />
  );
}

export default LeftNavigation;
